import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { NotAloneStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type NotAloneStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const NotAloneStep = ({ id, renderQuizScreen }: NotAloneStepProps) => {
  const logger = useLogger();

  const { back, next, stepData } = useQuizStep(id);

  if (!stepData) {
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const goBack = async () => back();

  const onContinue = async () => {
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        ...(stepData as NotAloneStepData),
      })}
    </>
  );
};

export default NotAloneStep;
